import React, { useEffect, useState } from "react";
import ScrollAnimation from "src/components/ScrollAnimation";
import GalleryItem from "./shared/ProjectItem";
import ContactUs from "./shared/ContactUs";
import { useLoading } from "src/hooks/useLoading";
import useFirebase from "src/hooks/useFirebase";

export default function Projects({ title = "DỰ ÁN THỰC TẾ", category = "all" }) {
  const [projects, setProjects] = useState([]);
  const loading = useLoading();
  const { getProjects } = useFirebase();

  useEffect(() => {
    async function fetchData() {
      localStorage.setItem('@category', category);
      loading.showLoading();
      const data = await getProjects(category)
      setProjects(data.filter(el => el.hidden !== true));
      loading.hideLoading()
    }
    category && fetchData()
  }, [category])

  return (
    <div>
      {/* text section */}
      <div className="flex flex-col items-center m-[10px] md:m-[20px] my-[30px]">
        <div className="flex flex-col gap-[10px] md:gap-[10px]">
          <ScrollAnimation animateIn="animation-fadeIn">
            <h3 className="uppercase text-primary text-[48px] md:text-[60px]" style={{lineHeight: 1.25}}>
              {title}
            </h3>
          </ScrollAnimation>
          <ScrollAnimation animateIn="mt-0 animate-bounceInRight">
            <div className="h-[1px] w-[200px] bg-black" />
          </ScrollAnimation>
          <p className="text-primary w-full sub-text-size" style={{ fontSize: parseInt(14) }}>
            Hidiarch ra đời nhằm mang đến những giá trị thẩm mỹ, tối ưu công năng
            cho không gian sống cũng như lan toả niềm đam mê, nhiệt huyết của tuổi
            trẻ, góp phần phát triển và vươn xa hơn cho nền kiến trúc Việt Nam.
          </p>
        </div>
      </div>
      {/* images section */}
      <div
        className="px-2 lg:px-0 w-full md:py-[30px]"
        style={{ backgroundColor: "#76817d" }}
      >
        <div className="container mx-auto h-auto grid grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-[32px] justify-start">
          {projects.map((el, index) => (
            <GalleryItem item={el} key={index} />
          ))}
        </div>
      </div>
      {/* contact us section*/}
      <ContactUs />
    </div>
  );
}
